export const MAIN_ROUTES = [
  'status',
  'assets',
  'applications',
  'authorization',
  'configuration',
  'release-notes',
  'profile',
  'remote-access',
  'sessions',
  'activity-log',
  'file-transfer',
];
export const [
  STATUS,
  ASSETS,
  APPLICATIONS,
  AUTH,
  CONFIG,
  RELEASE_NOTES,
  PROFILE,
  REMOTE_ACCESS,
  SESSIONS,
  ACTIVITY_LOG,
  FILE_TRANSFER,
] = MAIN_ROUTES;

const APPLICATION_ROUTES = [
  'security',
  'assetmanagement',
  'control',
  'analyzermanagement',
  'virtualization',
];
const APPLICATION_SUBROUTES = APPLICATION_ROUTES.map(
  subroute => `${APPLICATIONS}/${subroute}`
);

export const [
  APPLICATION_SECURITY,
  APPLICATION_ASSETMANAGEMENT,
  APPLICATION_CONTROL,
  APPLICATION_ANALYZERMANAGEMENT,
  APPLICATION_VIRTUALIZATION,
] = APPLICATION_SUBROUTES;

const ASSET_ROUTES = [
  'discovery-field',
  'discovery',
  'compute',
  'field',
  'plcdcs',
  'network',
  'env',
];
const ASSET_SUBROUTES = ASSET_ROUTES.map(subroute => `${ASSETS}/${subroute}`);
export const [
  ASSET_DISCOVERY_FIELD,
  ASSET_DISCOVERY,
  ASSET_COMPUTE,
  ASSET_FIELD,
  ASSET_PLCDCS,
  ASSET_NETWORK,
  ASSET_ENV,
] = ASSET_SUBROUTES;

const AUTH_ROUTES = ['users', 'groups'];
const AUTH_SUBROUTES = AUTH_ROUTES.map(subroute => `${AUTH}/${subroute}`);
export const [AUTH_USERS, AUTH_GROUPS] = AUTH_SUBROUTES;

const SESSIONS_ROUTES = ['requests', 'sessions'];
const SESSIONS_SUBROUTES = SESSIONS_ROUTES.map(
  subroute => `${SESSIONS}/${subroute}`
);
export const [SESSION_REQUESTS, SESSION_SESSIONS] = SESSIONS_SUBROUTES;
